export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-shape/src/identity.js
// module id = 1059
// module chunks = 1